import { useTranslation } from 'react-i18next';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import LegalDocument from 'pages/legal-document/LegalDocument';
import { LegalDocumentKind } from 'utils/legalDocuments';
import './LegalDocument.scss';

export const TermsPage = () => <LegalDocument kind={LegalDocumentKind.TermsAndConditions}/>;
export const PrivacyPage = () => <LegalDocument kind={LegalDocumentKind.PrivacyPolicy}/>;
export const CookiesPage = () => <LegalDocument kind={LegalDocumentKind.CookiePolicy}/>;
export const SizesChartPage = () => <LegalDocument kind={LegalDocumentKind.SizesChart}/>;

/** The return policy is plain text in the translations, so it is rendered as text, not as a PDF. */
export const ReturnsPage = () => {
  const { t } = useTranslation();
  const title = t('footer.returnPolicy');
  const paragraphs: string[] = String(t('footer.returnPolicyText')).split(/\n+/).filter(Boolean);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{`${title} | 2kiddo`}</title>
          <meta name="description" content={paragraphs[0]}/>
        </Helmet>
      </HelmetProvider>
      <section className="flex flex-column legal-document">
        <h1 className="legal-document-title">{title}</h1>
        {paragraphs.map((paragraph, index) => <p key={index} className="legal-document-text">{paragraph}</p>)}
      </section>
    </>
  );
};
